import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { REST_BASE_URL } from '../app.config';

@Injectable()
export class ScannerService {

  constructor(private http: HttpClient) {
  }

  decodeBarcodeToAntrag(barcode: string): Observable<any> {
    const headers = new HttpHeaders()
    .set('Content-Type', 'application/base64');

    return this.http.post<any>(REST_BASE_URL + '/visum-antrag/decode', barcode, { headers: headers });
  }
}
